import { render } from "./ZhaiTwoTuttons.vue?vue&type=template&id=24024f9e&scoped=true"
import script from "./ZhaiTwoTuttons.vue?vue&type=script&lang=js"
export * from "./ZhaiTwoTuttons.vue?vue&type=script&lang=js"

import "./ZhaiTwoTuttons.vue?vue&type=style&index=0&id=24024f9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24024f9e"]])

export default __exports__